export enum TabsType {
  Company = 'company',
  Earnings = 'earnings',
  Economics = 'economics',
}
